import Chart from 'chart.js';
import {formatCurrency, formatTooltipStack} from '../../functions/formatGraphic.js';
const Lang = require('lang');


/**
 * Class para criação de Cráfico do tipo de Stack
 */
class Stack {

  /**
   * Contrutor da classe
   *
   * @param  {element} element  Elemento HTML
   * @param  {Oject} data       Dados do gráfico
   */
  constructor(element, data) {
    this.element = element;
    this.data = data;
    // Labels do gráfico (mes/trimestre/ano)
    this.labels = [];
    // O data com os valores de cada status
    // em cada período
    this.dataSet = [];
  }

  /**
   * Cores a serem utilizadas, definidas
   * estáticamente com as cores do vexpenses
   *
   * @param  {string} prop
   *
   * @return {string} Cor em RGB
   */
  colors(prop) {
    const colors = {
      aprovado: 'rgba(156,201,107, .8)',
      reprovado: 'rgba(247,108,81, .8)',
      pago: 'rgba(85,85,85, .8)',
      aberto: 'rgba(95,162,221, .8)',
      enviado: 'rgba(0,157,179, .8)',
      reaberto: 'rgba(235,170,75, .8)',
      avulso: 'rgba(154,68,255, .8)'
    };
    return colors[prop];
  }

  /**
   * Tradução das labels de status das
   * despesas
   *
   * @param  {string} prop
   *
   * @return {string}
   */
  labelsStatus(prop) {
    const labelsStatus = {
      aprovado: 'approved',
      reprovado: 'disapproved',
      pago: 'paid',
      aberto: 'open',
      enviado: 'sent',
      reaberto: 'reopened',
      avulso: 'loose'
    };
    return Lang.get('js/src/classes/Graphics.' + labelsStatus[prop]);
  }

  /**
   * Tradução dos meses do ano
   *
   * @param  {int} indice
   *
   * @return {string}
   */
  labelMonth(indice) {
    const month = [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december'
    ];
    return Lang.get('js/src/classes/Graphics.' + month[indice - 1]).substring(0,3);
  }

  /**
   * Chamar o método de consulta de tradução
   *
   * @param  {string} label
   *
   * @return {string}
   */
  labelFormatText(label) {
    const prop = label.toLowerCase();
    return this.labelsStatus(prop);
  }

  /**
   * Criação dos objetos que serão utilizados
   * como data para a crição do gráfico, a criação
   * de sua quantidade é feita de acordo com
   * a quantidade labels de status existentes.
   * Em sua criação é definido o label que dado terá,
   * os valores apra o respectivo dado (status)
   * cor da dado no gráfico
   *
   * É importante que aqui se tena a definição de cada
   * um dos status que será usado como dado do gráfico,
   * na ordem correta (a mesma ordem dos danos que estão
   * sendo retornado pelo bakcEnd, do caso contrário ele
   * vai fazer confusão no local onde os dados são colocados)
   */
  prepareDataObject() {
    this.data.status.forEach((label) => {
      const nameColor = label.toLowerCase();
      const dataSetObject = {
        label: this.labelFormatText(label),
        data: [],
        backgroundColor: this.colors(nameColor),
      };
      this.dataSet.push(dataSetObject);
    });
  }

  /**
   * Transformar Objeto em Array
   *
   * @param  {Object} data dados no formato objeto
   * @return {array}      dados no formato array
   */
  arrayToValue(data) {
    return Object.keys(data).map((key) => {
      return data[key];
    });
  }

  /**
   * Preparando os dados para o caso de o
   * período de representação ser Anual
   */
  prepareDataYearly() {
    // Chama o método para definir o objeto no dataSet
    this.prepareDataObject();
    // Define a label dos anos
    this.labels = Object.keys(this.data.anual);
    // Transforma o data em um array de anos, contendo objetos dentro de cada ano
    const dataYearly = this.arrayToValue(this.data.anual);
    // percorrendo o array de ano
    dataYearly.forEach((data) => {
      let count = 0;
      // transforma em array os valores contido entro
      // do ano atual que está sendo percorrido no laço
      const dataStatus = this.arrayToValue(data);
      dataStatus.forEach((value) => {
        //adiciona o valor que está contido em cada um
        //dos indices no data set correspondete,
        //como está contecendo incremento, ele vai
        // adicionar no local correto já
        this.dataSet[count].data.push(value);
        count++;
      });
    });
  }

  /**
   * Definição da escrita das Labels Trimestrais
   * Realiza a escrita adequada das labels para o caso dos
   * trimestres
   */
  defineLabelsQuartely() {
    //Pega o texto de todos os anos existentes na chave trimestral
    //Como o valor do ano é usado como chave ele pega todas as
    //chaves de ano dentro deste array
    const labelsYears = Object.keys(this.data.trimestral);
    // transforma os anos em arrays, restando objetos de trismestres dentro
    // de cada um deles
    const dataYearly = this.arrayToValue(this.data.trimestral);
    let count = 0;
    // Percorre o Ano tranformado em array
    dataYearly.forEach((yearly) => {
      // Pega o ano atual que está sendo percorrido
      // inciando um laço nos seus trimestres
      Object.keys(yearly).forEach((quartely) => {
        // Montando a string da label de trimestre
        let label = quartely + 'º -'
        label += Lang.get('js/src/classes/Graphics.quarter').substring(0, 3);
        label += '/' + labelsYears[count];
        // adiciona no atributo da classe que contem as labels
        this.labels.push(label);
      });
      // incrementa o indice para que se possa pegar o próximo ano quando
      // este acabar
      count++;
    });
  }

  /**
   * Preparação dos dados que serão utilizados
   * para montar os gráficos
   */
  prepareDataQuarterly() {
    // Chama o método para definir o objeto do dataSet
    this.prepareDataObject();
    // Cha o método para definir as labels que serão utilizadas
    this.defineLabelsQuartely();
    // Transforma os anos do objeto trimestral em array
    const dataYearly = this.arrayToValue(this.data.trimestral);
    // Percorrendo os anos
    dataYearly.forEach((dataQuartely) => {
      // Transformando os trimestres em array
      const quartely = this.arrayToValue(dataQuartely);
      quartely.forEach((dataValues) => {
        // Para cada um dos trisestres tranforma os valores contidos
        // neles em array
        const values = this.arrayToValue(dataValues);
        let count = 0;
        // Percorrendo o array de valores do trimestres
        values.forEach((value) => {
          // Adicionando o valor contido no objeto correto
          // do dataSet, para garantir que todos os status
          // tenham os seu valores
          this.dataSet[count].data.push(value);
          count++;
        });
      });
    });
  }

  /**
   * Defunindo as Labels para a exibição dos
   * dados de mês
   */
  defineLabelsMonthly() {
    // Obetendo todos os anos dentro do período de mes
    const labelsYears = Object.keys(this.data.mensal);
    // Transforamndo os anos em array
    const dataYearly = this.arrayToValue(this.data.mensal);
    let count = 0;
    // Percorendo os anos tranformados em array
    dataYearly.forEach((yearly) => {
      // Pegando todos os meses dentro de cada um dos anos
      Object.keys(yearly).forEach((monthly) => {
        // Concatenando os valores para a criação do label
        // utilizando o valor do ano obtido anteriormente
        const label = this.labelMonth(monthly) + '/' + labelsYears[count];
        // Adicionando a Label concatenada
        this.labels.push(label);
      });
      count++;
    });
  }

  /**
   * Preparando o DataSet para a exbição
   * do dados por mês
   */
  prepareDataMonthly() {
    // Preparando os objetos que serão armazenados no dataSet
    // no caso a estrutura deles
    this.prepareDataObject();
    // Chamando a definição das labels de meses
    this.defineLabelsMonthly();
    // Convertendo os anos dentro do objeto mensal em array
    const dataYearly = this.arrayToValue(this.data.mensal);
    // Percorrendo o array de anos
    dataYearly.forEach((dataMonthly) => {
      // Dentro de cada ano existe os meses contendo os dados a serem utilizados
      // convertendo em array os objetos de meses
      const monthly = this.arrayToValue(dataMonthly);
      // Percorrendo o array de meses
      monthly.forEach((dataValues) => {
        // Dentro de ada mês contem os respectivos valores
        // para os status das despesas
        // // Convertendo os valores em array
        const values = this.arrayToValue(dataValues);
        let count = 0;
        // Percorrendo o array de valores
        values.forEach((value) => {
          // Adicionando o valor ao dataSet
          this.dataSet[count].data.push(value);
          count++;
        });
      });
    });
  }

  /**
   * Método de criação de gráficos,
   * seguindo a estrutura do Chartjs,
   * incluindo as opçõe que podem ser atribuídas
   *
   * @return {Charjs} Instância de Chartjs do tipo Stack
   */
  createChart() {
    return new Chart(this.element, {
      type: 'bar',
      data: {
        labels: this.labels,
        datasets: this.dataSet
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return formatTooltipStack(tooltipItem, data);
            }
          }
        },
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              callback: function (value) {
                return formatCurrency(value);
              }
            }
          }]
        }
      }
    });
  }
}
export default Stack;
